import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const container = styled('div')`
  padding: 20px;
`;

const greyBox = styled('div')`
  background-color: var(--ph-gray-100);
  padding: 30px;
`;

const contentContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
`;

const accessDeniedTextArea = styled('div')`
  flex: 1;
  font-size: var(--ph-text-sm);
  line-height: 3;
  color: var(--black);
  margin: 5px 0 0 20px;
`;

const buttonContainer = styled('span')`
  width: 100%;
  margin-top: 30px;
`;

const icon = styled(Svg)`
  width: 50px;
  height: 50px;
`;

export default {
  AccessDeniedTextArea: accessDeniedTextArea,
  ButtonContainer: buttonContainer,
  Container: container,
  ContentContainer: contentContainer,
  GreyBox: greyBox,
  Icon: icon,
};
